import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import Bank from "../../Assets/Projects/bank.png";
import BattleCheap from "../../Assets/Projects/warship.png";
import CiriousGame from "../../Assets/Projects/biohazard.png";
import StationBlanche from "../../Assets/Projects/station-blanche.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Mes derniers <strong className="purple">Projets </strong>
        </h1>
        <p style={{ color: "white" }}>
          Voici quelques projets sur lesquels j'ai travaillé récemment.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={CiriousGame}
              isBlog={false}
              title="CiriousGame"
              description="Projet de jeu éducatif codé en JavaScript avec le framework Phaser. Le joueur doit éradiquer un virus en utilisant différentes réformes pouvant être implémentées. Une approche ludique des problématiques sanitaires."
              ghLink="https://github.com/mehdidch59/CiriousGame"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Bank}
              isBlog={false}
              title="Gestion de banque"
              description="Simulation bancaire développée en C++ avec Qt. Le système implémente trois banques connectées via sockets et une base de données SQL pour gérer crédits, dépôts, prêts et transferts entre établissements."
              ghLink="https://github.com/mehdidch59/gestion-banque"
            />
          </Col>
        </Row>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={BattleCheap}
              isBlog={false}
              title="BattleCheap"
              description="Jeu multijoueur inspiré de la bataille navale, développé en JavaScript avec Socket.io pour la communication en temps réel. Les joueurs s'affrontent en détruisant les navires ennemis sur une grille tactique."
              ghLink="https://github.com/mehdidch59/BattleCheap"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={StationBlanche}
              isBlog={false}
              title="Station Blanche USB"
              description="Solution sécurisée d'analyse antivirus pour périphériques USB. Interface développée avec React Router et système backend intégrant ClamAV pour la détection des menaces."
              ghLink="https://github.com/mehdidch59/ZenKey"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;